import { proxy } from 'valtio'

const state = proxy({
  intro: true,
  colors: ['#ccc', '#d47f32', '#000000'],
  environments: ['sunset', 'night', 'park'],
  environment: "sunset",
  road_styles: {
	"white": {
		color:"#FFFFFF",
		metalness: 0.1,
		roughness: 0,
		emissiveIntensity: 0,
		emissive: "#000000",
		night: false,
	},
	"black": {
		color:"#000000",
		metalness: 0.1,
		roughness: 1,
		emissiveIntensity: 0,
		emissive: "#000000",
		night: false,
	},
	"gold": {
		color:"#c4a854",
		metalness: 0.1,
		roughness: 1,
		emissiveIntensity: 0,
		emissive: "#000000",
		night: false,
	},
	"mirror": {
		color:"#FFFFFF",
		metalness: 1,
		roughness: 0,
		emissiveIntensity: 0,
		emissive: "#000000",
		night: false,
	},
	"light": {
		color:"#FFFFFF",
		metalness: 0,
		emissiveIntensity: 1,
		roughness: 1,
		emissive: "#FFFFFF",
		night: true,
	}
  },
  water_styles: {
	"tosca_green": {
		color:"#00b0a3",
		metalness: 0.1,
		roughness: 1,
		emissiveIntensity: 0,
		emissive: "#000000",
		night: false,
	},
	"blue": {
		color:"#25a9df",
		metalness: 0.1,
		roughness: 1,
		emissiveIntensity: 0,
		emissive: "#000000",
		night: false,
	},
	"tivoli_blue": {
		color:"#31009d",
		metalness: 0.1,
		roughness: 1,
		emissiveIntensity: 0,
		emissive: "#000000",
		night: false,
	},
	"black": {
		color:"#000000",
		metalness: 0.1,
		roughness: 1,
		emissiveIntensity: 0,
		emissive: "#000000",
		night: false,
	},
	"white": {
		color:"#ffffff",
		metalness: 0.1,
		roughness: 0,
		emissiveIntensity: 0,
		emissive: "#000000",
		night: false,
	},
	"mirror": {
		color:"#ffffff",
		metalness: 1,
		roughness: 0,
		emissiveIntensity: 0,
		emissive: "#000000",
		night: false,
	},
	"light": {
		color:"#FFFFFF",
		metalness: 0,
		emissiveIntensity: 1,
		emissive: "#FFFFFF",
		roughness: 1,
		show:false,
		night: true,
	}
  },
  background_styles: {
	"mirror": {
		color:"#ffffff",
		metalness: 1,
		roughness: 0,
		emissiveIntensity: 0,
	},
	"black": {
		color:"#000000",
		metalness: 0.1,
		roughness: 1,
		emissiveIntensity: 0,
	},
	// "light": {
		// color:"#FFFFFF",
		// metalness: 0,
		// roughness: 1,
		// emissiveIntensity: 1,
		// show:false
	// }
  },
  sizes: ['12x18', '15x20', '20x25', '24x30', '30x40', '40x60'],
  frame_sizes: {
	  landscape: {
		'12x18': {
			width: 18,
			height: 12,
			zoom: 2,
			price: 10,
		},
		'15x20': {
			width: 20,
			height: 15,
			zoom: 1.2,
			price: 18,
		},
		'20x25': {
			width: 25,
			height: 20,
			zoom: 2,
			price: 20,
		},
		'24x30': {
			width: 30,
			height: 24,
			zoom: 2,
			price: 36,
		},
		'30x40': {
			width: 40,
			height: 30,
			zoom: 2,
			price: 54,
		},
		'40x60': {
			width: 60,
			height: 40,
			zoom: 2.2,
			price: 96,
		},
	  },
	  portrait: {
		'12x18': {
			width: 12,
			height: 18,
			zoom: 2,
			price: 10,
		},
		'15x20': {
			width: 15,
			height: 20,
			zoom: 2,
			price: 18,
		},
		'20x25': {
			width: 20,
			height: 25,
			zoom: 1.2,
			price: 20,
		},
		'24x30': {
			width: 24,
			height: 30,
			zoom: 1.5,
			price: 36,
		},
		'30x40': {
			width: 30,
			height: 40,
			zoom: 1.8,
			price: 54,
		},
		'30x60': {
			width: 30,
			height: 60,
			zoom: 2.3,
			price: 78,
		},
		'40x60': {
			width: 40,
			height: 60,
			zoom: 2.3,
			price: 96,
		},
	  },
  },
  orientation: ['landscape', 'portrait'],
  cities: ['kampot', 'phnompenh', 'sihanoukville', 'siemreap'],
  styles: {
	"classic": {
		name: "Classic",
		environment: "sunset",
		stylefile: "classic",
		color: "#d47f32",
		road_color: 'black',
		water_color: 'blue',
		background_color: 'mirror',
	},
	"pro": {
		name: "Original",
		environment: "sunset",
		stylefile: "pro",
		color: "#d47f32",
		road_color: 'black',
		water_color: 'blue',
		background_color: 'mirror',
	},
	"vintage": {
		name: "Vintage",
		environment: "sunset",
		stylefile: "old",
		color: "#d47f32",
		road_color: 'black',
		water_color: 'blue',
		background_color: 'mirror',
	},
	"night": {
		name: "Invert",
		environment: "sunset",
		stylefile: "pro",
		color: "#000000",
		road_color: 'mirror',
		water_color: 'blue',
		background_color: 'black',
	},
	// "light": {
		// environment: "night",
		// stylefile: "pro",
		// color: "#d47f32",
		// road_color: 'light',
		// water_color: 'blue',
		// background_color: 'mirror',
		// show:false
	// },
	"custom": {
		stylefile: "pro",
		color: "#d47f32",
		road_color: 'black',
		water_color: 'blue',
		background_color: 'mirror',
	}
  },
  presets: {
	"original": {
		name: "Original",
		color: "#d47f32",
		road_color: 'black',
		water_color: 'blue',
		background_color: 'mirror',
		night: false,
	},
	"light": {
		name: "Light",
		color: "#cccccc",
		road_color: 'black',
		water_color: 'white',
		background_color: 'mirror',
		night: false,
	},
	"dark": {
		name: "Dark",
		color: "#000000",
		road_color: 'black',
		water_color: 'black',
		background_color: 'mirror',
		night: false,
	},
	"night": {
		name: "Night",
		color: "#000000",
		road_color: 'mirror',
		water_color: 'blue',
		background_color: 'black',
		night: true,
	},
	"LED": {
		name: "LED",
		color: "#d47f32",
		road_color: 'light',
		water_color: 'blue',
		background_color: 'mirror',
		light: true,
		night: true,
	},
  },
	mirrors: {
		"bangkok": {
			name: "Bangkok",
			country: "th",
			default: {
				orientation: "portrait",
				size: "30x40",
				zoom: "25000",
				style: "pro"
			},
			sizes: {
				portrait: {
					'30x40': {
						'25000': ['pro', 'night'],
					},
				},
			},
		},
		"battambang": {
			name: "Battambang",
			country: "kh",
			default: {
				orientation: "portrait",
				size: "30x40",
				zoom: "25000",
				style: "pro"
			},
			sizes: {
				portrait: {
					'30x40': {
						'25000': ['pro', 'night'],
					},
				},
			},
		},
		"kampongcham": {
			name: "Kampong Cham",
			country: "kh",
			default: {
				orientation: "portrait",
				size: "24x30",
				zoom: "25000",
				style: "pro"
			},
			sizes: {
				portrait: {
					'24x30': {
						'25000': ['pro', 'night'],
					},
				},
			},
		},
		"kampongchhnang": {
			name: "Kampong Chhnang",
			country: "kh",
			default: {
				orientation: "portrait",
				size: "30x40",
				zoom: "75000",
				style: "pro"
			},
			sizes: {
				portrait: {
					'30x40': {
						'75000': ['pro', 'night'],
					},
				},
			},
		},
		"kampot": {
			name: "Kampot",
			country: "kh",
			default: {
				orientation: "portrait",
				size: "40x60",
				zoom: "25000",
				style: "pro"
			},
			sizes: {
				landscape: {
					'15x20': {
						'17500': ['pro', 'night'],
					},
				},
				portrait: {
					'24x30': {
						'60000': ['classic', 'pro', 'night', 'vintage'],
						'25000': ['pro', 'night'],
					},
					'30x40': {
						'25000': ['pro', 'night'],
						'100000': ['pro', 'night'],
					},
					'40x60': {
						'25000': ['pro', 'night'],
					},
				},
			},
		},
		"kohkong": {
			name: "Koh Kong",
			country: "kh",
			default: {
				orientation: "portrait",
				size: "30x40",
				zoom: "50000",
				style: "pro"
			},
			sizes: {
				portrait: {
					'30x40': {
						'50000': ['pro', 'night'],
					},
				},
			},
		},
		"phnompenh": {
			name: "Phnom Penh",
			country: "kh",
			default: {
				orientation: "portrait",
				size: "30x40",
				zoom: "25000",
				style: "pro"
			},
			sizes: {
				landscape: {
					'15x20': {
						'50000': ['pro', 'night'],
					},
				},
				portrait: {
					'24x30': {
						'25000': ['pro', 'night'],
					},
					'30x40': {
						'25000': ['pro', 'night']
					},
					'30x60': {
						'25000': ['pro', 'night']
					},
					'40x60': {
						'25000': ['pro', 'night']
					},
				},
			},
		},
		"siemreap": {
			name: "Siem Reap",
			country: "kh",
			default: {
				orientation: "portrait",
				size: "40x60",
				zoom: "25000",
				style: "pro"
			},
			sizes: {
				landscape: {
					'15x20': {
						'17500': ['pro', 'night'],
					},
				},
				portrait: {
					'30x40': {
						'25000': ['pro', 'night'],
					},
					'40x60': {
						'25000': ['pro', 'night'],
					},
				},
			},
		},
		"sihanoukville": {
			name: "Sihanoukville",
			country: "kh",
			default: {
				orientation: "portrait",
				size: "40x60",
				zoom: "25000",
				style: "pro"
			},
			sizes: {
				portrait: {
					'30x40': {
						'75000': ['pro', 'night'],
						'25000': ['pro', 'night'],
					},
					'40x60': {
						'25000': ['pro', 'night'],
					},
				},
			},
		},
	},
  frame_colors: ['#ccc', '#EFBD4E', '#80C670', '#726DE8', '#EF674E', '#353934'],
  decals: ['day', 'night'],
  city: 'phnompenh',
  size: '30x40',
  orientation: 'portrait',
  zoom: '25000',
  style: 'pro',
  color: '#d47f32',
  road_color: 'black',
  water_color: 'blue',
  background_color: 'mirror',
  add_logo: false,
  decal: 'day',
  preset: 'original',
  showCanvaText: false,
  custom: false,
  onSidebar: false,
  night: false,
})

export { state }
